module.exports = __webpack_public_path__ + "assets/icon-codeable-logo-small.2057554d.svg";